import { useIntl } from '@edx/frontend-platform/i18n';
import PropTypes from 'prop-types';

import messages from './messages';

const Separator = ({ style }) => {
  const { formatMessage } = useIntl();

  return (
    <span className="separator flex-center-row gap-20" style={style}>
      <span className="line" />
      {formatMessage(messages['separator.or.text'])}
      <span className="line" />
    </span>
  );
};

Separator.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types, react/require-default-props
  style: PropTypes.any,
};

export default Separator;
